import { jsx } from 'react/jsx-runtime';
import { d as EGDSMenuList } from '../menu-icon-trigger/index-chunk.esm.js';
import { c as classNames, d as EGDSContextProvider } from '../theme-provider/index-chunk.esm.js';
import styles from '../styles/uitk-egds-skip-link.css';

const getClassNameList = classNames.bind(styles);
const EGDSSkipLink = (props) => {
    const { className, id, items } = props;
    const wrapperClassNames = getClassNameList('uitk-skip-link uitk-skip-link-is-visually-hidden', className);
    const contextData = { isInSkipLink: true };
    return (jsx("div", { id: id, className: wrapperClassNames, children: jsx(EGDSContextProvider, { config: { context: 'egds-skip-link-context', data: contextData }, children: jsx(EGDSMenuList, { items: items }) }) }));
};
EGDSSkipLink.displayName = 'EGDSSkipLink';

export { EGDSSkipLink as E };
//# sourceMappingURL=index-chunk.esm.js.map
